module.exports = __webpack_public_path__ + "static/media/bytt-nn-6.645933bd.mp3";